import { render } from "./editSubsPage.vue?vue&type=template&id=520e7260"
import script from "./editSubsPage.vue?vue&type=script&lang=js"
export * from "./editSubsPage.vue?vue&type=script&lang=js"

import "./editSubsPage.vue?vue&type=style&index=0&id=520e7260&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__